import validate from 'validate.js'

const constraints = {
  lessonPaymentEditInput: {
    presence: true
  },
  lessonId: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
